import React from "react";
import PropTypes from "prop-types";

const WaterBarrierIcon = ({
  width,
  height,
  className,
  color,
  stroke,
  strokeWidth,
  ...props
}) => {
  const strokeColor =
    stroke && stroke !== "currentColor" ? stroke : color || "currentColor";

  return (
    <svg
      width={width || 16}
      height={height || 16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M14 5.33359C13.9995 4.85773 13.7454 4.41819 13.3333 4.18026L8.66667 1.51359C8.25413 1.27542 7.74587 1.27542 7.33333 1.51359L2.66667 4.18026C2.25455 4.41819 2.00049 4.85773 2 5.33359V10.6669C2.00049 11.1428 2.25455 11.5823 2.66667 11.8203L7.33333 14.4869C7.74587 14.7251 8.25413 14.7251 8.66667 14.4869L13.3333 11.8203C13.7454 11.5823 13.9995 11.1428 14 10.6669V5.33359"
        stroke={strokeColor}
        strokeWidth={strokeWidth || "1.33333"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.19922 4.66699L7.99922 8.00033L13.7992 4.66699"
        stroke={strokeColor}
        strokeWidth={strokeWidth || "1.33333"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 14.6667V8"
        stroke={strokeColor}
        strokeWidth={strokeWidth || "1.33333"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

WaterBarrierIcon.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
  color: PropTypes.string,
  stroke: PropTypes.string,
  strokeWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

WaterBarrierIcon.defaultProps = {
  width: undefined,
  height: undefined,
  className: "",
  color: undefined,
  stroke: undefined,
  strokeWidth: undefined,
};

export default WaterBarrierIcon;
